/// <amd-module name="Wiki/Filter/WikiPageFilterStrategy" />
import { WikiPage } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { IWikiPageFilterStrategy, IWikiPageFilterStrategyOptions } from "Wiki/Filter/Contracts";
import { FilteredWikiPage } from "Wiki/PageTree/Contracts";

export abstract class WikiPageFilterStrategy implements IWikiPageFilterStrategy {
    protected _options: IWikiPageFilterStrategyOptions;
    protected _allPages: WikiPage[];

    constructor(options?: IWikiPageFilterStrategyOptions) {
        this._options = options || {};
        this._allPages = [];
    }

    public filter(query: string): FilteredWikiPage[] {
        // TODO: add telemetry here
        return this._filterInternal(query);
    }

    public setAllFilterItems(items: WikiPage[]): void {
        this._allPages = items;
    }

    public abstract shouldFilter(query: string): boolean;

    protected abstract _filterInternal(query: string): FilteredWikiPage[];
}
